$(function () {

	let intersectionObserver = new IntersectionObserver(entries => {
		entries.forEach(entity => {
			if (!entity.isIntersecting) {
				return;
			}
			const target = entity.target

			intersectionObserver.unobserve(target);

			if (target.dataset.src) {
				target.src = target.dataset.src;
			}

			if (entity.target.dataset.srcset) {
				entity.target.srcset = entity.target.dataset.srcset;
			}

			if (entity.target.dataset.sizes) {
				entity.target.sizes = entity.target.dataset.sizes;
			}

			if (entity.target.dataset.backgroundImage) {
				entity.target.style.backgroundImage = entity.target.dataset.backgroundImage;
			}

			if (entity.target.dataset.isIntersectionClass) {
				entity.target.classList.add(entity.target.dataset.isIntersectionClass);
			}

			if (entity.target.dataset.loadingClass || entity.target.dataset.completeClass) {
				if (entity.target.complete === false) {
					if (entity.target.dataset.loadingClass) {
						entity.target.classList.add(entity.target.dataset.loadingClass);
					}

					$(entity.target).one('load', function () {
						if (entity.target.dataset.completeClass) {
							entity.target.classList.add(entity.target.dataset.completeClass);
						}

						if (entity.target.dataset.loadingClass) {
							entity.target.classList.remove(entity.target.dataset.loadingClass);
						}
					});
				} else if (entity.target.complete === true) {
					if (entity.target.dataset.completeClass) {
						entity.target.classList.add(entity.target.dataset.completeClass);
					}
				}
			}
		});
	}, {
		rootMargin: '200px',
		threshold: 0.01
	});

	let mutationObserver = new MutationObserver(mutations => {
		mutations.forEach(mutation => {
			mutation.addedNodes.forEach(addedNode => {
				if (addedNode.nodeType !== Node.ELEMENT_NODE) {
					return;
				}

				if (addedNode.classList.contains('intersection-target')) {
					intersectionObserver.observe(addedNode)
				}

				addedNode.querySelectorAll('.intersection-target').forEach(target => intersectionObserver.observe(target));
			});
		});
	});

	document.querySelectorAll('.intersection-target').forEach(target => intersectionObserver.observe(target));

	mutationObserver.observe(document.documentElement, {
		subtree: true,
		childList: true
	});
});
